// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__16B3q","content":"styles_content__aLTwP","selectAll":"styles_selectAll__OYkni"};